import { render } from "./FundDetailView.vue?vue&type=template&id=cc1677f2&ts=true"
import script from "./FundDetailView.vue?vue&type=script&lang=ts"
export * from "./FundDetailView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__